export const currencyFormat = (num) => num || num === 0 ? `${num.toFixed(0).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ')},-` : null